import { Reit } from "../types/reit.types";

export interface ProcessedReitData {
  reitYearData: Reit["years"][number] | null;
  nseData: any;
  bseData: any;
  uniqueLocations: string[];
  sponsors: string[];
  description: string;
  assetClass: string;
}

export const processReitData = (reit: Reit | null): ProcessedReitData => {
  if (!reit) {
    return {
      reitYearData: null,
      nseData: null,
      bseData: null,
      uniqueLocations: [],
      sponsors: [],
      description: "",
      assetClass: "",
    };
  }

  const latestYear = reit.years?.length
    ? reit.years.reduce(
        (max, y) => (y.year > max.year ? y : max),
        reit.years[0]
      )
    : null;

  const uniqueLocations = reit.realEstateLocData
    ? Array.from(
        new Set(
          reit.realEstateLocData.map((loc) => String(loc.location?.value ?? ""))
        )
      )
    : [];

  const nseData =
    latestYear?.marketPositioning?.find((mp) => mp.exchange.value === "NSE") ||
    null;
  const bseData =
    latestYear?.marketPositioning?.find((mp) => mp.exchange.value === "BSE") ||
    null;

  const sponsors = reit.about?.[0]?.sponsors
    ? Array.from(new Set(reit.about[0].sponsors.map((s) => s.name || "")))
    : [];

  const description =
    reit.about?.map((a) => String(a.description?.value ?? "")).join(" ") || "";

  const assetClasses =
    reit.about
      ?.map((a) => String(a.primaryassetclass?.value ?? ""))
      .filter(Boolean) || [];
  const assetClass = assetClasses.length ? assetClasses.join(", ") : "";
  const formattedAssetClass = assetClass.replaceAll(",", ", ");

  return {
    reitYearData: latestYear || null,
    nseData,
    bseData,
    uniqueLocations,
    sponsors,
    description,
    assetClass: formattedAssetClass,
  };
};
